import { cn } from "../../lib/utils.ts";

export const GmailIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      role="img"
      aria-label="Gmail"
      className={cn(className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.636 20.25h3.819V11.7L0 7.609v11.001c0 .906.732 1.64 1.636 1.64z" fill="#4285F4" />
      <path d="M18.545 20.25h3.819c.904 0 1.636-.734 1.636-1.64v-11l-5.455 4.09z" fill="#34A853" />
      <path d="M18.545 4.594V11.7L24 7.609V5.414c0-2.026-2.313-3.182-3.927-1.964z" fill="#FBBC04" />
      <path d="M5.455 11.7V4.594L12 9.502l6.545-4.908V11.7L12 16.609z" fill="#EA4335" />
      <path
        d="M0 5.414V7.61l5.455 4.09V4.595L3.927 3.45C2.313 2.232 0 3.388 0 5.414z"
        fill="#C5221F"
      />
    </svg>
  );
};
